var SearchResults = function () {

	this.init = function () {

		$('[data-component="search-results"] .btn-bordered').on('click', function (event) {
			event.preventDefault();
			$('[data-component="search-results"] .btn-bordered').removeClass('active');
			$(this).toggleClass('active');
		})

	}

	return this.init();
}

$('.botoes #todos').addClass('active');

$('.botoes button').click(function(){
	var botao = $(this).attr('id');
	$('.resultado').hide();
	if(botao == "todos"){
		$('.resultado').show();
		$('.result-search').hide();
		$('.result-search:first').show();
	} else {
		$('.result-search').show();
		$('.'+botao).show();
	}
});

$('#post, #perguntas_frequentes, #page').click(function(){
	$('.pagnationSearch').hide();
});

$('#todos').click(function(){
	$('a.current').removeClass('current');
	$('.pageSearch a').first().addClass('current');
	$('.previous-search').hide();
	$('.next-search').show();
	$('.pagnationSearch').show();
});

$('.result-search').hide();
$('.result-search:first').show();
$('.previous-search').hide();

$('.pageSearch a').click(function(){
	// e.preventDefault();
	$('.pageSearch a').removeClass('current');
	$(this).addClass('current');
	let numPage = $(this).attr('data-page');
	$('.result-search').hide();
	$('.resultPag-'+numPage).show();
});

$('.pagnationSearch .next-search').click(function(){
	let page = parseInt($('.pageSearch .current').attr('data-page'));
	if (page != 0){
		let numPage = page + 1;
		$('.pageSearch .current').next().addClass('current');
		$('.pageSearch .current').prev().removeClass('current');
		let ultimo = $('.pageSearch a').last().attr('data-page') - 1;
		if( page == ultimo){
			$(this).hide();
		}
		$('.previous-search').show();
		$('.result-search').hide();
		$('.resultPag-'+numPage).show();
	}
});

$('.pagnationSearch .previous-search').click(function(){
	let page = parseInt($('.pageSearch .current').attr('data-page'));
	if (page != 0){
		let numPage = page - 1 ;
		$('.pageSearch .current').prev().addClass('current');
		$('.pageSearch .current').next().removeClass('current');
		let primeiro = $('.pageSearch a').first().attr('data-page');
		if($('a.current').attr('data-page') == 1){
			$('.previous-search').hide();
		}
		$('.next-search').show();
		$('.result-search').hide();
		$('.resultPag-'+numPage).show();
	}
});
